var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 120,
    viewBox: "0 0 128 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.025 91.823L80.0411 9.13156C72.8138 -3.03577 55.1956 -3.05194 47.9585 9.13156L2.97713 91.823C-4.41117 104.256 4.53383 120 19.0147 120H108.983C123.452 120 132.413 104.269 125.025 91.823ZM63.9998 105.077C59.8866 105.077 56.5384 101.729 56.5384 97.6158C56.5384 93.5025 59.8866 90.1543 63.9998 90.1543C68.1131 90.1543 71.4612 93.5025 71.4612 97.6158C71.4612 101.729 68.1131 105.077 63.9998 105.077ZM71.4612 75.2315C71.4612 79.3447 68.1131 82.6929 63.9998 82.6929C59.8866 82.6929 56.5384 79.3447 56.5384 75.2315V37.9244C56.5384 33.8112 59.8866 30.463 63.9998 30.463C68.1131 30.463 71.4612 33.8112 71.4612 37.9244V75.2315Z",
    fill: "#17468C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.319202585ce18405a8e2846f88c5f6e1.svg";
export { ForwardRef as ReactComponent };